// extracted by mini-css-extract-plugin
export default {"loanHistoryForm":"loanHistoryForm---Kg15t"};